// We are using different loggers for node and browser environments.
// If we want to log something from the `/shared` folder we need to pull in the right logger.
// So here we figure out if we are in the browser or node env and return the right one.
if (process.env.RUNTIME_ENV === 'BROWSER') {
  module.exports = require('../../ui/lib/logging')
} else {
  module.exports = require('../../src/lib/logging')
}
